'use client';

import { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'nav-blur shadow-lg shadow-black/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <AppLogo
          text="NightBurnOJ"
          iconName="FireIcon"
          size={64}
        />

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-cream-muted">
          {['Science', 'Ingredients', 'Reviews']?.map((item) => (
            <a
              key={item}
              href={`#${item?.toLowerCase()}`}
              className="hover:text-citrus transition-colors duration-200"
            >
              {item}
            </a>
          ))}
        </div>

        {/* CTA */}
        <a
          href="#order"
          className="hidden md:inline-flex items-center gap-2 bg-citrus hover:bg-citrus-light text-white font-semibold text-sm px-5 py-2.5 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-citrus/30 hover:-translate-y-0.5"
        >
          Order Now
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>

        {/* Mobile toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden text-cream p-2"
          aria-label="Toggle menu"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {menuOpen ? (
              <>
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </>
            ) : (
              <>
                <path d="M4 6h16M4 12h16M4 18h16" />
              </>
            )}
          </svg>
        </button>
      </div>
      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden nav-blur border-t border-citrus/10 px-6 py-4 space-y-4">
          {['Science', 'Ingredients', 'Reviews']?.map((item) => (
            <a
              key={item}
              href={`#${item?.toLowerCase()}`}
              onClick={() => setMenuOpen(false)}
              className="block text-cream-muted hover:text-citrus transition-colors text-sm font-medium py-1"
            >
              {item}
            </a>
          ))}
          <a
            href="#order"
            onClick={() => setMenuOpen(false)}
            className="block w-full text-center bg-citrus text-white font-semibold text-sm px-5 py-3 rounded-full mt-2"
          >
            Order Now
          </a>
        </div>
      )}
    </nav>
  );
}